import { useParams } from 'react-router-dom';
import SupOrgTripDetails from './SupOrgTripDetails';
import SupOrgGuideDetails from './supOrgGuideDetails/SupOrgGuideDetails';
import SupOrgActivityDetails from './supOrgActivityDetails/SupOrgActivityDetails';
import SupOrgAccommodationDetails from './SupOrgAccommodationDetails';

const SupOrgDetailsWrapper = () => {
    const { mode } = useParams();

    /*
     * 'c' (camp/accommodation) had no entry here at all, so
     * opening any accommodation listing's details from the
     * Packages list rendered nothing (SupOrgDetailsComponent
     * came back undefined and this component returns null).
     */
    const SupOrgDetailsComponents = {
        t: SupOrgTripDetails,
        g: SupOrgGuideDetails,
        a: SupOrgActivityDetails,
        c: SupOrgAccommodationDetails
    };
    const SupOrgDetailsComponent = SupOrgDetailsComponents[mode];
    return SupOrgDetailsComponent ? <SupOrgDetailsComponent /> : null;
};

export default SupOrgDetailsWrapper;
